import { Language } from "./langType";

export default <Language>{
  Sports: {
    "American Football": "Amerikietiškas futbolas",
    Baseball: "Beisbolas",
    Basketball: "Krepšinis",
    Boxing: "Boksas",
    Chess: "Šachmatai",
    Cricket: "Kriketas",
    Darts: "Smiginis",
    Entertainment: "Pramogos",
    "E-Sports": "E-Sportas",
    Football: "Futbolas",
    "Formula 1": "Formulė 1",
    "Gaelic Football": "Gėlų futbolas",
    "Generic Sport": "Bendras sportas",
    Golf: "Golfas",
    "Greyhound Racing": "Kurtų lenktynės",
    Handball: "Rankinis",
    "Ice Hockey": "Ledo ritulys",
    IndyCar: "IndyCar",
    MMA: "Mišrieji kovų menai",
    Nascar: "Nascar",
    Politics: "Politika",
    "Rugby League": "Regbio lyga",
    "Rugby Union": "Regbio sąjunga",
    Snooker: "Snukeris",
    "Table Tennis": "Stalo tenisas",
    Tennis: "Tenisas",
    "Virtual Football": "Virtualus futbolas",
    "Virtual Greyhound Racing": "Virtual Greyhound Racing",
    "Virtual Horse Racing": "Virtual Horse Racing"
  },
  MarketTexts: {
    ToWin: "{name} laimės",
    WinFirstRound: "{name} laimės pirmą raundą",
    FirstTouchdown: "{name} pelnys pirmą prispaudimą",
    FirstTry: "{name} bandys pirmas įmušti",
    TotalGoals: "{name} viso įvarčių",
    TotalRuns: "{name} viso bėgimų",
    TotalPoints: "{name} viso taškų",
    TopBatsman: "{name} bus geriausias Atmušėjas",
    TopBowler: "{name} bus geriausias Ridentojas",
    FirstScore: "{name} įmuš pirmas"
  },
  PromoTexts: {
    Pick: "Atlikite savo pasirinkimą",
    Bet: "Lažintis",
    Pays: "Moka"
  },
  DateTimeTexts: {
    Today: "Šiandien",
    Tomorrow: "Rytoj",
    Live: "Tiesiogiai"
  },
  ButtonTexts: {
    Draw: "X"
  },
  ParlayTexts: {
    Picks: "Atlikite savo pasirinkimą",
    Return: "Moka",
    Stake: "Lažintis",
    Draw: "X"
  },
  H2HTexts: {
    // general
    "Per match": "per varžybas",
    H2H: "H2H",
    W: "P",
    D: "L",
    L: "PR",
    T: "L",

    // soccer
    goals_scored: "Įmušti įvarčiai",
    shots: "Smūgiai",
    shots_on_target: "Smūgiai į vartų plotą",
    ball_possession: "Kamuolio kontroliavimas",
    goals_conceded: "Praleisti įvarčiai",

    // baseball
    runs_per_game: "Runs",
    runs_allowed_per_game: "Runs Allowed",
    hits_per_game: "Hits",
    batting_average: "AVG",
    on_base_percentage: "OBP",
    slugging_percentage: "SLG",
    home_runs: "HR",
    stolen_bases: "SB",
    earned_run_average: "ERA",
    walks_hits_per_inning_pitched: "WHIP",
    strikeouts_per_9_innings: "K/9",
    homeruns_allowed_per_game: "HR",
    batting_average_against: "BA",
    batting_stats: "Batting/Running",
    pitching_stats: "Pitching/Defence",

    // american football
    points_per_game: "Points",
    points_allowed_per_game: "Points Allowed",
    rushing_stats: "Rushing Stats",
    rushing_yards_per_game: "Rushing Yards",
    rushing_touchdowns: "Rushing Touchdowns (total)",
    rushing_percentage: "Rushing %",
    passing_stats: "Passing Stats",
    passing_yards_per_game: "Passing Yards",
    passing_touchdowns: "Passing Touchdowns (total)",
    passing_percentage: "Passing %"
  }
};
